import React, { Suspense, useEffect, useState } from "react";
import ViewAdminCommunity from "../../components/pageComponents/adminDashboard/community/ViewAdminCommunity";
import AdminDashboardLayout from "./AdminDashboardLayout";
import Cookies from 'universal-cookie';

const AdminCommunity = () => {

  const [ipData ,setIpData] = useState(false);
  
    useEffect(() => {
      const cookies = new Cookies(null, { path: '/' });
      fetch('https://api.ipgeolocation.io/getip')
      .then(response => response.json())
      .then(data => {
        setIpData(data);
      });
  
    },[]);
  
    useEffect(() => {
  
      if(ipData) {
        let apiKey    = 'fedb7d47ed89400fbfcfad81e99d4569';
        let apiDevKey = '689d9f5de95341a086320edefc75d4a2';
        const cookies = new Cookies(null, { path: '/' });
      
        if(cookies.get('geolocation') == undefined) {
          fetch(`https://api.ipgeolocation.io/timezone?apiKey=${apiDevKey}&ip=${ipData.ip}`)
          .then(response => response.json())
          .then(data => {
            cookies.set('geolocation', data?.timezone);
          });
        }  
      }
      
    },[ipData]);

  return (
    <AdminDashboardLayout>
      <ViewAdminCommunity />
    </AdminDashboardLayout>
  );
};

export default AdminCommunity;
